"use strict";

import Swiper from 'swiper';

export function initInScope ($scope) {
    $scope.find('.js-swiper-container').each(function (index, value) {
        let $swiperContainer = $(this),
            $swiperMain = $swiperContainer.find('.js-product-detail-swiper-main'),
            $swiperNav = $swiperContainer.find('.js-product-detail-swiper-nav'),
            $swiperArrowContainerMain = $swiperMain.closest('.js-swiper-arrow-container'),
            $swiperArrowContainerNav = $swiperNav.closest('.js-swiper-arrow-container');

        let spaceBetween = $swiperContainer.is('.product-detail-swiper--intranet') ? 20 : 40;
        let spaceBetweenSmall = $swiperContainer.is('.product-detail-swiper--intranet') ? 10 : 20;
        let slides = $swiperContainer.is('.product-detail-swiper--intranet') ? 3 : 4;

        let swiperNav = new Swiper ($swiperNav, {
            loop: false,
            slidesPerView: slides,
            spaceBetween: spaceBetweenSmall,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: $swiperArrowContainerNav.find('.js-swiper__next'),
                prevEl: $swiperArrowContainerNav.find('.js-swiper__prev'),
            },
            breakpoints: {
                // when window width is >= 1300px
                1300: {
                    spaceBetween: spaceBetween
                }
            }
        });

        new Swiper ($swiperMain, {
            loop: false,
            slidesPerView: 1,
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: $swiperArrowContainerMain.find('.js-swiper__next'),
                prevEl: $swiperArrowContainerMain.find('.js-swiper__prev'),
            },
            pagination: {
                el: $swiperContainer.find('.js-swiper__pagination'),
                clickable: true
            },
            thumbs: {
                swiper: matchMedia('(max-width: 767px)').matches ? null : swiperNav
            },
            breakpoints: {
                // when window width is >= 768px
                768: {
                    pagination: {
                        el: null
                    }
                }
            }

        });

    });
    

}